import { BarsGlyph, MapGlyph, PeopleGlyph, PersonGlyph, RouteGlyph } from "./navGlyphs";

export type NavTab = {
  to: string;
  i18nKey: string;
  icon: React.ReactNode;
};

export const TABS: NavTab[] = [
  { to: "/", i18nKey: "nav.tab_map", icon: <MapGlyph /> },
  { to: "/route-planner", i18nKey: "nav.tab_route", icon: <RouteGlyph /> },
  { to: "/activity", i18nKey: "nav.tab_activity", icon: <BarsGlyph /> },
  { to: "/community", i18nKey: "nav.tab_community", icon: <PeopleGlyph /> },
  { to: "/profile", i18nKey: "nav.tab_profile", icon: <PersonGlyph /> },
];

export function isTabActive(pathname: string, tabPath: string): boolean {
  // `/` and `/chargers` both render the workspace (config.ts) — share-links
  // and old bookmarks reach the second; the map tab must light up for either.
  if (tabPath === "/" && (pathname === "/" || pathname === "/chargers")) return true;
  return pathname === tabPath || pathname.startsWith(tabPath + "/");
}
